module.exports = __webpack_public_path__ + "img/initial_d_bg.5e4a795c.jpg";